module.exports = __webpack_public_path__ + "img/edit-img.a3830db8.svg";